let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kKUHt")).then(() => parcelRequire('9rB8a'));